import React, { Component, Fragment } from "react";
import { Button, Modal } from "semantic-ui-react";
import { withRouter } from "react-router-dom";
import config from "../../../../.samples.config";

class Timer extends Component {
  state = { modalOpen: false, tokenExpiration: null, expiredModalOpen: false };
  redirectToLogin = async () => {
    await this.props.msalContext.instance.logoutRedirect({
      account: this.props.msalContext.instance.getActiveAccount(),
      postLogoutRedirectUri: window.location.origin
    });
  };
  handleClose = () => this.setState({ modalOpen: false });
  closeExpiredModal = () => {
    this.setState({ expiredModalOpen: false });
  };
  async renewTokens() {
    const { instance, accounts } = this.props.msalContext;
    const account = instance.getActiveAccount() || accounts[0];
    if (account) {
      await instance.acquireTokenSilent({
        ...config.msal.tokenRequest,
        account,
        forceRefresh: true
      });
    }
    this.setState({ modalOpen: false });
  }
  renewSession = async () => {
    this.renewTokens();
  };
  async componentDidUpdate() {
    const { instance, accounts } = this.props.msalContext;
    const account = instance.getActiveAccount() || accounts[0];
    const claims = account && account.idTokenClaims;
    if (claims && claims.exp) {
      const currentTokenExpiration = new Date(claims.exp * 1000);
      if (
        !this.state.tokenExpiration ||
        currentTokenExpiration.getTime() !== this.state.tokenExpiration.getTime()
      ) {
        this.executeAt(currentTokenExpiration.getTime(), () => {
          this.setState({ expiredModalOpen: true });
        });
        this.setState({ tokenExpiration: currentTokenExpiration });
      }
    }
  }

  executeAt(time, func) {
    const currentTime = new Date().getTime();
    setTimeout(func, time - currentTime);
    return true;
  }

  render() {
    return (
      <Fragment>
        <Modal
          closeIcon
          size="small"
          style={{ height: "20vh", marginTop: "30vh" }}
          centered={false}
          open={this.state.modalOpen}
        >
          <Modal.Header>
            <p style={{ fontSize: "16px" }}>Session Expiring</p>
          </Modal.Header>
          <Modal.Content scrolling>
            <Modal.Description>
              <p style={{ fontSize: "14px" }}>
                Your current login session will expire in 10 minutes. Do you
                like to renew your login session?
              </p>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              positive
              icon="checkmark"
              labelPosition="right"
              content="Yes"
              onClick={this.renewSession}
            />
            <Button negative onClick={this.handleClose}>
              No
            </Button>
          </Modal.Actions>
        </Modal>

        <Modal
          centered={false}
          open={this.state.expiredModalOpen}
          size="small"
          style={{ height: "22vh", marginTop: "30vh" }}
        >
          <Modal.Header>Session Expired</Modal.Header>
          <Modal.Content scrolling>
            <Modal.Description>
              <p style={{ fontSize: "14px" }}>
                Your previous login session expired and you have been logged out
                of application.
              </p>
            </Modal.Description>
          </Modal.Content>
          <Modal.Actions>
            <Button
              className="button-hover submit-cancle"
              color="blue"
              basic
              onClick={this.redirectToLogin}
            >
              Login
            </Button>
          </Modal.Actions>
        </Modal>
      </Fragment>
    );
  }
}

export default withRouter(Timer);
